// extracted by mini-css-extract-plugin
export var backHomeLink = "CancelSubscriptionFinal_backHomeLink__iyqMo";
export var cancelSubscriptionFinalContainer = "CancelSubscriptionFinal_cancelSubscriptionFinalContainer__t81W0";
export var cancelSubscriptionFinalContent = "CancelSubscriptionFinal_cancelSubscriptionFinalContent__6wr-D";
export var checked = "CancelSubscriptionFinal_checked__3mJdq";
export var extraNote = "CancelSubscriptionFinal_extraNote__9Mlh3";
export var md = "768px";
export var note = "CancelSubscriptionFinal_note__x-VKX";
export var question = "CancelSubscriptionFinal_question__k4nGg";
export var reactivateButton = "CancelSubscriptionFinal_reactivateButton__1jt7B";
export var shared = "'../../shared.module.css'";
export var title = "CancelSubscriptionFinal_title__8Xxu8";